app.controller('AccountPaymentProcessingController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    const paymentID = $stateParams.payment_id;
    $scope.processing_alerts = null;

    $rootScope.service.account.getAccountPaymentStatus(paymentID, function (success, paymentResponse, messages) {

        if (success) {
            $state.go('myba.account-payment-acknowledgement', {payment_id: paymentResponse._id});
        } else {
            $scope.processing_alerts = messages && messages.length > 0 ? messages : $rootScope.site_helper.addErrorMessage("A error occurred. Your payment did not process");
        }
    });

}]);